import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

class AllertDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showContainer: false
		};

		this.handleClick = this.handleClick.bind(this);
	}

	componentWillMount() {
		document.addEventListener('click', this.handleClick, false);
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClick, false);
	}

	handleClick(e) {
		if (this.node.contains(e.target)) {
			return false;
		}

		this.props.closeDialogClicked(e);
	}

	render() {
		const {
			styles,
			title,
			description,
			button,
			onClick,
			theme,
			body,
			height
		} = this.props;

		const containerStyles = {
			minHeight: '290px',
			height: 'auto',
			top: `calc(50% - ${height})`
		};

		return (
			<div className="AllertDialog" style={styles}>
				<div
					className="AllertDialog-container"
					ref={node => (this.node = node)}
					style={containerStyles}
				>
					<div className="AllertDialog-content">
						<h3 className="AllertDialog-title">{title}</h3>
						{body}
						{description && (
							<div
								className="AllertDialog-description"
								dangerouslySetInnerHTML={{ __html: description }}
							/>
						)}
					</div>
					<div className="AllertDialog-footer">
						<button
							className={`AllertDialog-button AllertDialog-button--${theme}`}
							onClick={onClick}
						>
							{button}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

AllertDialog.propTypes = {
	closeDialogClicked: PropTypes.func,
	styles: PropTypes.object,
	show: PropTypes.bool,
	icon: PropTypes.string,
	description: PropTypes.string,
	button: PropTypes.string,
	cancelClicked: PropTypes.func,
	acceptClicked: PropTypes.func,
	onClick: PropTypes.func,
	height: PropTypes.number
};

AllertDialog.defaultProps = {
	show: false,
	title: 'Deleting record',
	description:
		'Are you sure you want to delete this record?<br />Once deleted it cannot be recovered.',
	button: 'ok',
	theme: 'red',
	height: 290
};

export default AllertDialog;
